module.exports = __webpack_public_path__ + "static/media/ROBLOX.a8efa9f4.svg";